import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
// import "./Management6.css";

import { FaTrash, FaSave, FaEdit } from "react-icons/fa";
import ProcurementTable from "../Food/ProcurementTable";
import ProcurementCart from "../Food/ProcurementCart";
import axios from "axios";

const Groceryinventorydata = () => {
    const [activeTab, setActiveTab] = useState("Raw Material");
    // const [editModes, setEditModes] = useState({});
    const fileInputRef = useRef(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [editPopupOpen, setEditPopupOpen] = useState(false);
    const [selectedChefId, setSelectedChefId] = useState(null);
    const [chefUsage, setChefUsage] = useState([]);
    const [editModes, setEditModes] = useState([]);

    const [editForm, setEditForm] = useState({
        chefName: "",
        itemName: "",
        consume: 0,
        date: "",
    });

    const [data1, setData1] = useState([]);

    const handleInputFocus = (index) => {
        // Make only the selected row editable
        const newEditModes = {};
        newEditModes[index] = true;
        setEditModes(newEditModes);
    };
    const handleEditPopupOpen = async (id) => {
        setSelectedChefId(id);
        try {
            const authToken = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/inventory/chef/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = response.data;
            setEditForm({
                chefName: data.chefName,
                itemName: data.itemName,
                consume: data.consume,
                date: data.date?.split("T")[0] || "",
            });
            setEditPopupOpen(true);
        } catch (error) {
            console.error("❌ Failed to fetch chef data:", error);
            alert("Error loading chef data.");
        }
    };

    const handleEditSubmit = async () => {
        if (!selectedChefId) return;

        try {
            const authToken = localStorage.getItem("authToken");
            await axios.put(
                `https://backend.maamaas.com/food/inventory/chef/update/${selectedChefId}`,
                editForm,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            alert("✅ Data updated successfully!");
            setEditPopupOpen(false);
            // Optionally re-fetch the list:
            // fetchChefUsage();
        } catch (error) {
            console.error("❌ Error updating chef data:", error);
            alert("Failed to update chef data.");
        }
    };

    useEffect(() => {
        const fetchChefUsage = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId || !authToken) {
                alert("Missing vendorId or authToken");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/inventory/chef/vendor/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                const formatted = response.data.map((item) => ({
                    id: item.id, // ✅ include ID
                    chefName: item.chefName || "",
                    itemName: item.itemName || "",
                    consume: item.consume || 0,
                    date: item.date || new Date().toISOString().split("T")[0],
                }));

                setChefUsage(formatted);
            } catch (error) {
                console.error("❌ Error fetching chef usage data:", error);
                alert("Failed to fetch chef usage data.");
            }
        };

        fetchChefUsage();
    }, []);

    const handleDeleteRow2 = async (index, id) => {
        if (!id) {
            alert("❌ No ID found for this row.");
            return;
        }

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this entry?"
        );
        if (!confirmDelete) return;

        try {
            const authToken = localStorage.getItem("authToken");

            console.log("Deleting ID:", id); // ✅ debug
            const res = await axios.delete(
                `https://backend.maamaas.com/food/inventory/chef/delete/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (res.status === 200 || res.status === 204) {
                const updatedList = chefUsage.filter((_, i) => i !== index);
                setChefUsage(updatedList);
                alert("✅ Deleted successfully");
            } else {
                alert("❌ Failed to delete");
            }
        } catch (err) {
            console.error("❌ Error deleting row:", err.response || err);
            alert("❌ Delete request failed");
        }
    };

    const handleSubmitUsage = async (index) => {
        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("Missing vendorId or authToken");
            return;
        }

        const row = chefUsage[index];

        const payload = {
            id: 0,
            chefName: row.chefName,
            itemName: row.itemName,
            consume: parseFloat(row.consume) || 0,
            date: row.date || new Date().toISOString().split("T")[0],
            vendorId: parseInt(vendorId),
        };

        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/inventory/consume/${vendorId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("✅ Usage submitted:", response.data);
            alert("✅ Usage submitted successfully!");
        } catch (error) {
            console.error(
                "❌ Error submitting usage:",
                error.response?.data || error.message
            );
            alert("❌ Failed to submit usage. Check console for details.");
        }
    };

    // ============================================================  Inventory Table ============================================/

    useEffect(() => {
        const fetchInventoryData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");

            if (!vendorId || !authToken) {
                alert("Missing vendorId or authToken");
                return;
            }

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/inventory/get-item/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${authToken}`,
                        },
                    }
                );

                console.log("Full response:", response.data);

                // Skip date filtering for now
                const uniqueItems = response.data.filter(
                    (item, index, self) =>
                        self.findIndex((i) => i.itemName === item.itemName) === index
                );

                const formattedData = uniqueItems.map((item, index) => ({
                    itemId: item.id,
                    SNo: index + 1,
                    item: item.itemName || "",
                    quantity: item.quantity || "",
                    consumed: item.consumed || 0,
                    balance: item.balance || 0,
                    procurementValue: item.procurementValue || 0,
                }));

                console.log("Formatted Data:", formattedData);
                setData1(formattedData);
            } catch (error) {
                console.error("Error fetching inventory:", error);
                alert("Failed to fetch inventory data.");
            }
        };

        fetchInventoryData();
    }, []);

    const handleSubmitInventory = async (index) => {
        const authToken = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId") || "42";
        const item = data1[index];

        if (!item.item || !item.quantity) {
            alert("❗ Item name and quantity are required.");
            return;
        }

        const payload = {
            itemName: item.item,
            quantity: parseFloat(item.quantity) || 0,
            consumed: parseFloat(item.consumed) || 0,
            balance: parseFloat(item.balance) || 0,
            procurementValue: parseFloat(item.procurementValue) || 0,
            date: new Date().toISOString().split("T")[0],
            vendorId: parseInt(vendorId),
        };

        const isUpdate = !!item.itemId;

        try {
            const url = isUpdate
                ? `https://backend.maamaas.com/food/inventory/${item.itemId}`
                : `https://backend.maamaas.com/food/inventory/add/${vendorId}`;

            const method = isUpdate ? "put" : "post";

            const response = await axios[method](url, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json",
                },
            });

            alert(`✅ Item ${isUpdate ? "updated" : "added"} successfully`);

            // Disable edit mode
            const updatedEditModes = [...editModes];
            updatedEditModes[index] = false;
            setEditModes(updatedEditModes);

            // Save itemId if POST created it
            if (!isUpdate && response.data?.id) {
                const updated = [...data1];
                updated[index].itemId = response.data.id;
                setData1(updated);
            }
        } catch (error) {
            console.error("❌ Error saving inventory item:", error);
            alert("❌ Failed to save item.");
        }
    };

    const handleEditInventory = async (index, itemId) => {
        const authToken = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!authToken || !vendorId) {
            alert("Missing auth token or vendor ID");
            return;
        }

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/inventory/${itemId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        vendorId: vendorId, // include only if required by backend
                    },
                }
            );

            console.log("✅ Inventory item fetched:", response.data);

            setSelectedItem(response.data);
            setIsPopupOpen(true);
        } catch (error) {
            console.error("❌ Error fetching inventory item:", error);
            if (error?.response?.status === 403) {
                alert(
                    "❌ Could not fetch item details: Access forbidden. Check if your token is expired or missing permissions."
                );
            } else {
                alert("❌ Unexpected error. Check console.");
            }
        }
    };

    const handleUpdateInventory = async () => {
        const authToken = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!authToken || !vendorId) {
            alert("Missing auth token or vendor ID");
            return;
        }

        try {
            await axios.put(
                `https://backend.maamaas.com/food/inventory/update/${selectedItem.id}`,
                selectedItem,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        vendorId: vendorId,
                        "Content-Type": "application/json",
                    },
                }
            );
            alert("✅ Item updated successfully");
            setIsPopupOpen(false);
        } catch (error) {
            console.error("❌ Error updating item:", error);
            alert("❌ Failed to update item");
        }
    };

    const handleSaveRow = (index) => {
        setEditModes((prev) => ({
            ...prev,
            [index]: false,
        }));
    };

    const handleAddRow1 = () => {
        const newRow = {
            SNo: (data1.length + 1).toString(),
            item: "",
            quantity: "",
            consumed: "",
            balance: "",
            procurementValue: "",
        };

        const updatedData = [...data1, newRow];
        const updatedEditModes = [...editModes, true]; // mark new row as editable

        setData1(updatedData);
        setEditModes(updatedEditModes);
    };

    useEffect(() => {
        if (editModes.length !== data1.length) {
            setEditModes(data1.map((_, idx) => editModes[idx] ?? true));
        }
    }, [data1]);

    const handleInputChange1 = (e, index) => {
        const { name, value } = e.target;

        const updatedData = [...data1];
        updatedData[index][name] = value;

        // Optional: auto-calculate balance
        if (name === "quantity" || name === "consumed") {
            const quantity = parseFloat(updatedData[index].quantity) || 0;
            const consumed = parseFloat(updatedData[index].consumed) || 0;
            updatedData[index].balance = (quantity - consumed).toString();
        }

        setData1(updatedData);
    };

    const handleDeleteRow1 = async (index) => {
        const item = data1[index];
        const authToken = localStorage.getItem("authToken");

        if (!item.itemId) {
            alert("Item ID not found.");
            return;
        }

        try {
            await axios.delete(
                `https://backend.maamaas.com/food/inventory/delete/${item.itemId}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // Update UI by removing the deleted item from state
            const updatedData = [...data1];
            updatedData.splice(index, 1);
            setData1(updatedData);

            alert("Item deleted successfully!");
        } catch (error) {
            console.error("❌ Error deleting item:", error);
            alert("Failed to delete item.");
        }
    };

    const handleImportClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const importedData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const formattedData = importedData.slice(1).map((row, index) => ({
                SNo: (data1.length + index + 1).toString(),
                item: row[0] || "",
                quantity: row[1] || "",
                consumed: row[2] || "",
                balance: (
                    (parseFloat(row[1]) || 0) - (parseFloat(row[2]) || 0)
                ).toString(),
                procurementValue: row[4] || "",
            }));

            setData1((prevData) => [...prevData, ...formattedData]);
        };
        reader.readAsArrayBuffer(file);
    };

    ///////////=======chef======///////////

    const handleAddChefUsage = () => {
        // Add new row
        const newRow = {
            chefName: "",
            itemName: "",
            consume: "",
            date: new Date().toISOString().split("T")[0],
        };

        // Set only last row as editable (true), rest false
        const updatedEditModes = chefUsage.map(() => false);
        updatedEditModes.push(true); // Only new row is editable

        setChefUsage([...chefUsage, newRow]);
        setEditModes(updatedEditModes);
    };

    const handleChefChange = (e, index) => {
        const { name, value } = e.target;
        const updated = [...chefUsage];
        updated[index][name] = value;
        setChefUsage(updated);
    };

    const handleDelete = (index) => {
        const updated = chefUsage.filter((_, i) => i !== index);
        setChefUsage(updated);
    };

    const tabContent = {
        "Raw Material": (
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                        onClick={handleAddRow1}
                        style={{ ...addButtonStyle, fontWeight: "bold" }}
                    >
                        Add+
                    </button>
                    <button
                        onClick={handleImportClick}
                        style={{ ...importButtonStyle, fontWeight: "bold" }}
                    >
                        Import
                    </button>
                    <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                        ref={fileInputRef}
                        style={{ display: "none" }}
                    />
                </div>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "-5px",
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th style={tableHeaderStyle}>S.No</th>
                            <th style={tableHeaderStyle}>Item Name</th>
                            <th style={tableHeaderStyle}>Quantity</th>
                            <th style={tableHeaderStyle}>Consumed</th>
                            <th style={tableHeaderStyle}>Balance</th>
                            <th style={tableHeaderStyle}>Procurement</th>
                            <th style={tableHeaderStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data1.map((item, index) => (
                            <tr
                                key={index}
                                style={index % 2 === 0 ? evenRowStyle : oddRowStyle}
                            >
                                <td style={tableCellStyle}>{item.SNo}</td>
                                <td style={tableCellStyle}>
                                    <input
                                        type="text"
                                        name="item"
                                        value={item.item}
                                        onChange={(e) => handleInputChange1(e, index)}
                                        style={inputStyle}
                                        readOnly={!editModes[index]}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        type="text"
                                        name="quantity"
                                        value={item.quantity}
                                        onChange={(e) => handleInputChange1(e, index)}
                                        style={inputStyle}
                                        readOnly={!editModes[index]}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        type="text"
                                        name="consumed"
                                        value={item.consumed}
                                        readOnly
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        type="text"
                                        name="balance"
                                        value={item.balance}
                                        readOnly
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        type="text"
                                        name="procurementValue"
                                        value={item.procurementValue}
                                        onChange={(e) => handleInputChange1(e, index)}
                                        style={inputStyle}
                                        readOnly={!editModes[index]}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    {editModes[index] ? (
                                        <button
                                            onClick={() => handleSubmitInventory(index)} // ✅ pass index
                                            style={{ ...editButtonStyle, backgroundColor: "green" }}
                                        >
                                            <FaSave />
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() =>
                                                handleEditInventory(index, data1[index].itemId)
                                            }
                                            style={{ ...editButtonStyle, backgroundColor: "#007bff" }}
                                        >
                                            <FaEdit />
                                        </button>
                                    )}
                                    <button
                                        onClick={() => handleDeleteRow1(index)}
                                        style={deleteButtonStyle}
                                    >
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {isPopupOpen && selectedItem && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0, 0, 0, 0.4)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                        }}
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: "24px 32px",
                                borderRadius: "12px",
                                width: "400px",
                                maxWidth: "90%",
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                                fontFamily: "sans-serif",
                            }}
                        >
                            <h3
                                style={{
                                    marginBottom: "16px",
                                    textAlign: "center",
                                    color: "#333",
                                }}
                            >
                                Edit Inventory Item
                            </h3>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        placeholder="Item Name"
                                        value={selectedItem.itemName}
                                        onChange={(e) =>
                                            setSelectedItem({
                                                ...selectedItem,
                                                itemName: e.target.value,
                                            })
                                        }
                                        style={{
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                        }}
                                    />
                                </div>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        type="number"
                                        placeholder="Quantity"
                                        value={selectedItem.quantity}
                                        onChange={(e) =>
                                            setSelectedItem({
                                                ...selectedItem,
                                                quantity: e.target.value,
                                            })
                                        }
                                        style={{
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                        }}
                                    />
                                </div>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        type="number"
                                        placeholder="Consumed"
                                        value={selectedItem.consumed}
                                        readOnly
                                        style={{
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                            backgroundColor: "#f9f9f9",
                                            color: "#666",
                                        }}
                                    />
                                </div>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        type="number"
                                        placeholder="Balance"
                                        value={selectedItem.balance}
                                        readOnly
                                        style={{
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                            backgroundColor: "#f9f9f9",
                                            color: "#666",
                                        }}
                                    />
                                </div>

                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <input
                                        type="number"
                                        placeholder="Procurement Value"
                                        value={selectedItem.procurementValue}
                                        onChange={(e) =>
                                            setSelectedItem({
                                                ...selectedItem,
                                                procurementValue: e.target.value,
                                            })
                                        }
                                        style={{
                                            padding: "8px",
                                            border: "1px solid #ccc",
                                            borderRadius: "6px",
                                            fontSize: "14px",
                                        }}
                                    />
                                </div>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "10px",
                                    marginTop: "20px",
                                }}
                            >
                                <button
                                    onClick={() => setIsPopupOpen(false)}
                                    style={{
                                        padding: "8px 16px",
                                        fontSize: "14px",
                                        border: "none",
                                        borderRadius: "6px",
                                        backgroundColor: "#ccc",
                                        color: "#333",
                                        cursor: "pointer",
                                    }}
                                >
                                    Close
                                </button>
                                <button
                                    onClick={handleUpdateInventory}
                                    style={{
                                        padding: "8px 16px",
                                        fontSize: "14px",
                                        border: "none",
                                        borderRadius: "6px",
                                        backgroundColor: "#28a745",
                                        color: "white",
                                        cursor: "pointer",
                                    }}
                                >
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        ),
        "Store Associate": (
            <div>
                <button onClick={handleAddChefUsage} style={addButtonStyle}>
                    Add +
                </button>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "0px",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={tableHeaderStyle}>S.No</th>
                            <th style={tableHeaderStyle}>Chef Name</th>
                            <th style={tableHeaderStyle}>Iteam Name</th>

                            <th style={tableHeaderStyle}>Consumed</th>
                            <th style={tableHeaderStyle}>Date</th>
                            <th style={tableHeaderStyle}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {chefUsage.map((row, index) => (
                            <tr
                                key={row.id || index}
                                style={index % 2 === 0 ? evenRowStyle : oddRowStyle}
                            >
                                <td style={tableCellStyle}>{index + 1}</td>
                                <td style={tableCellStyle}>
                                    <input
                                        name="chefName"
                                        value={row.chefName || ""}
                                        onChange={(e) => handleChefChange(e, index)}
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        name="itemName"
                                        value={row.itemName || ""}
                                        onChange={(e) => handleChefChange(e, index)}
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        name="consume"
                                        type="number"
                                        value={row.consume !== undefined ? row.consume : 0}
                                        onChange={(e) => handleChefChange(e, index)}
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    <input
                                        name="date"
                                        type="date"
                                        value={row.date || ""}
                                        onChange={(e) => handleChefChange(e, index)}
                                        style={inputStyle}
                                    />
                                </td>
                                <td style={tableCellStyle}>
                                    {editModes[index] ? (
                                        <button
                                            onClick={() => handleSubmitUsage(index)}
                                            style={{ ...editButtonStyle, backgroundColor: "green" }}
                                        >
                                            <FaSave />
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleEditPopupOpen(row.id)}
                                            style={{ ...editButtonStyle, backgroundColor: "#007bff" }}
                                        >
                                            <FaEdit />
                                        </button>
                                    )}
                                    <button
                                        onClick={() => handleDeleteRow2(index, row.id)}
                                        style={deleteButtonStyle}
                                    >
                                        <FaTrash />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {editPopupOpen && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "12px",
                                padding: "30px",
                                width: "400px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                                fontFamily: "Arial, sans-serif",
                            }}
                        >
                            <h3 style={{ marginBottom: "20px", textAlign: "center" }}>
                                Edit Chef Data
                            </h3>

                            <input
                                type="text"
                                placeholder="Chef Name"
                                value={editForm.chefName}
                                onChange={(e) =>
                                    setEditForm({ ...editForm, chefName: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "12px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    fontSize: "14px",
                                }}
                            />

                            <input
                                type="text"
                                placeholder="Item Name"
                                value={editForm.itemName}
                                onChange={(e) =>
                                    setEditForm({ ...editForm, itemName: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "12px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    fontSize: "14px",
                                }}
                            />

                            <input
                                type="number"
                                placeholder="Consumed Quantity"
                                value={editForm.consume}
                                onChange={(e) =>
                                    setEditForm({ ...editForm, consume: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "12px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    fontSize: "14px",
                                }}
                            />

                            <input
                                type="date"
                                value={editForm.date}
                                onChange={(e) =>
                                    setEditForm({ ...editForm, date: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "20px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    fontSize: "14px",
                                }}
                            />

                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <button
                                    onClick={handleEditSubmit}
                                    style={{
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Save
                                </button>
                                <button
                                    onClick={() => setEditPopupOpen(false)}
                                    style={{
                                        backgroundColor: "#f44336",
                                        color: "white",
                                        padding: "10px 20px",
                                        border: "none",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        ),
        Procurement: <ProcurementTable />,
        "Procurement Cart": <ProcurementCart />,
    };

    return (
        <div
            style={{
                overflowY: "auto",
                height: "550px",
                marginTop: "30px",
                scrollbarWidth: "none",
            }}
        >
            <div
                style={{ gap: "10px", display: "flex", justifyContent: "space-evenly" }}
            >
                {Object.keys(tabContent).map((label) => (
                    <button
                        key={label}
                        onClick={() => setActiveTab(label)}
                        style={{
                            border: "none",
                            borderRadius: "10px",
                            width: "130px",
                            height: "40px",
                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                            color: "#000",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "background-color 0.3s ease",
                        }}
                    >
                        {label}
                    </button>
                ))}
            </div>
            <div style={{ marginTop: "20px", borderRadius: "8px" }}>
                {tabContent[activeTab]}
            </div>
        </div>
    );
};

// Styles
const tableHeaderStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "#b15cd6",
    color: "white",
};

const tableCellStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
};

const evenRowStyle = {};
const oddRowStyle = { backgroundColor: "#fff" };

const inputStyle = {
    width: "100%",
    border: "none",
    textAlign: "center",
    backgroundColor: "transparent",
};

const addButtonStyle = {
    marginBottom: "10px",
    padding: "8px 16px",
    backgroundColor: "#b15cd6",
    color: "white",
    border: "none",
    cursor: "pointer",
    borderRadius: "5px",
    width: "100px",
};

const importButtonStyle = {
    height: "40px",
    width: "100px",
    backgroundColor: "#b15cd6",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
};

const editButtonStyle = {
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
    marginRight: "5px",
};

const deleteButtonStyle = {
    backgroundColor: "red",
    color: "white",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "5px",
};
const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999,
};

const modalStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    width: "300px",
};

export default Groceryinventorydata;
